/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusKundeDetailDto } from '../../models/lexplus-kunde-detail-dto';

export interface KundenControllerFindDetailV1$Params {
  kundeId: number;
}

export function kundenControllerFindDetailV1(http: HttpClient, rootUrl: string, params: KundenControllerFindDetailV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusKundeDetailDto>> {
  const rb = new RequestBuilder(rootUrl, kundenControllerFindDetailV1.PATH, 'get');
  if (params) {
    rb.path('kundeId', params.kundeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusKundeDetailDto>;
    })
  );
}

kundenControllerFindDetailV1.PATH = '/v1/kunden/{kundeId}';
